import computed from './computed'
import methods from './methods'

export default {
  computed,
  methods
}



// WEBPACK FOOTER //
// ./src/app/professional/config/resources/index.js